var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.775,
    height: 9.775,
    viewBox: "0 0 9.775 9.775",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.985,6.741A4.487,4.487,0,0,0,7.7,4.427a2.169,2.169,0,0,0,0-2.114A4.487,4.487,0,0,0,3.985,0,4.487,4.487,0,0,0,.275,2.313a2.169,2.169,0,0,0,0,2.114A4.487,4.487,0,0,0,3.985,6.741Z",
    transform: "translate(0.902 1.515)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2404",
    "data-name": "Grupo 2404"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M2.916,1.458A1.458,1.458,0,1,1,1.458,0,1.457,1.457,0,0,1,2.916,1.458Z",
    transform: "translate(3.429 3.429)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector-3",
    "data-name": "Vector",
    transform: "translate(9.775 9.775) rotate(180)",
    fill: "none",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H9.775V9.775H0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.000003814697266 1.000003814697266 L 1.000003814697266 8.774943351745605 L 8.774943351745605 8.774943351745605 L 8.774943351745605 1.000003814697266 L 1.000003814697266 1.000003814697266 M 3.814697265625e-06 3.814697265625e-06 L 9.774943351745605 3.814697265625e-06 L 9.774943351745605 9.774943351745605 L 3.814697265625e-06 9.774943351745605 L 3.814697265625e-06 3.814697265625e-06 Z",
    stroke: "none",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.9da794bf621ac0a22a1a89fc90545b4a.svg";
export { ForwardRef as ReactComponent };